import {
  CodeBook,
  ExportTypeEnum,
  PagedResult,
} from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { SaveResult } from "../../models";
import {
  Institution,
  InstitutionSearch,
  InstitutionCodeBookSearch,
  InstitutionCodeBook,
} from "../../models/Institution";
import {
  HierarchicalCodeBook,
  GreatGrandParentCodeBookPagedFilter,
} from "../../models/Shared";
import { InstitutionEditRequest } from "./../../models/Institution/InstitutionEditRequest";
import { InstitutionSchoolYearOtherEditRequest } from "../../models/Institution/InstitutionSchoolYearOtherEditRequest";

const apiUrlPrefix: string = "institutions";

export const searchPrograms = async (search: string) => {
  let url = `programs/search?name=${search}`;
  return api.get(url) as Promise<CodeBook[]>;
};

export const searchInstitutionNew = async (
  request: InstitutionCodeBookSearch
) => {
  return api.post(`${apiUrlPrefix}/search`, request) as Promise<
    InstitutionCodeBook[]
  >;
};

export const searchInstitutionFilteredNew = async (
  request: InstitutionSearch
) => {
  return api.post(`${apiUrlPrefix}/search-new`, request) as Promise<
    PagedResult<Institution>
  >;
};

export const getInstitutionById = async (
  id: number,
  schoolYearId: number,
  onlyActive?: boolean,
  NationalMinorityOrReligious?: boolean
) => {
  const isOnlyActive = !!onlyActive;
  const isNationalMinorityOrReligious = !!NationalMinorityOrReligious;
  return api.get(
    `${apiUrlPrefix}/get/${id}/${schoolYearId}/${isOnlyActive}/${isNationalMinorityOrReligious}`
  ) as Promise<Institution>;
};

export const getInstitutionListData = async (
  request: InstitutionSearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/institutions-export-list/${type}`,
    "post",
    request
  ) as Promise<any>;
};

export const editInstitution = async (
  institutionEditRequest: InstitutionEditRequest
) => {
  return api.post(
    `${apiUrlPrefix}/save-institution`,
    institutionEditRequest
  ) as Promise<SaveResult<InstitutionEditRequest>>;
};

export const editInstitutionSchoolYearOther = async (
  institutionSchoolYearOtherEditRequest: InstitutionSchoolYearOtherEditRequest
) => {
  return api.put(
    `${apiUrlPrefix}/institution-schoolYear-other`,
    institutionSchoolYearOtherEditRequest
  ) as Promise<SaveResult<InstitutionSchoolYearOtherEditRequest>>;
};

/**
 * This method throws an exception if the filter search term or id collection is not specified.
 * @param codeBookFilter
 * @param onlyEnrollment
 * @returns
 */
export const searchInstitutionFilterList = async (
  codeBookFilter: GreatGrandParentCodeBookPagedFilter,
  onlyEnrollment?: boolean
) => {
  return api.post(
    onlyEnrollment
      ? `${apiUrlPrefix}/search-institutions/${onlyEnrollment}`
      : `${apiUrlPrefix}/search-institutions`,
    codeBookFilter
  ) as Promise<PagedResult<HierarchicalCodeBook>>;
};
